<template>
  <div class="min-h-screen w-screen overflow-hidden flex flex-col justify-center">
    <div
        class="bg-white lg:shadow-lg p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-4xl">
      <div class="text-center">
        <h2 class="mt-8 mb-4 lg:my-10 text-2xl" v-html="$trans('app.invitations.thank_you_for_taking_test')"></h2>

        <p class="mb-6 lg:mb-10" v-html="$trans('app.invitations.coach_will_contact_you')"></p>
      </div>
    </div>
  </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import StepProgress from '@/Components/StepProgress.vue';
import BubbleLink from '@/Components/BubbleLink.vue';
import {Link} from '@inertiajs/inertia-vue3';

export default {
  name: "Thanks",
  props: {
  },
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    //
  }
}
</script>

<style scoped>

</style>
